/**
 * Shared storage-key constants for the unified auth flow.
 *
 * Producers (a forced sign-out in auth.js, email-entry's draft) and
 * consumers (email-entry) import the same symbol so a rename can't desync
 * the contract.
 */

/**
 * sessionStorage flag set by a forced sign-out in ``providers/auth.js``
 * and consumed once by /email-entry on mount to hide its back chevron —
 * there's nothing useful to navigate back into.
 */
export const JUST_LOGGED_OUT_KEY = "wone.auth.justLoggedOut";

/**
 * sessionStorage draft of the typed email; survives navigate-and-back
 * round trips between /email-entry and the chooser/OTP screens.
 */
export const EMAIL_DRAFT_KEY = "auth_email_draft";
